import React from 'react'

const STEPS = [
  {
    n: 1,
    title: 'School-Based Programs',
    text: 'We work directly with schools to deliver structured football training programs within the academic environment.',
  },
  {
    n: 2,
    title: 'Qualified Coaching',
    text: 'Our trained coaches focus on technical football skills, discipline, teamwork, and character development.',
  },
  {
    n: 3,
    title: 'Career Exposure',
    text: 'We teach practical, real-world skills and provide guidance, exposing young players to diverse career opportunities beyond football.',
  },
  {
    n: 4,
    title: 'Long-Term Support',
    text: 'We provide pathways for continued development, ensuring children succeed both within and beyond football.',
  },
]

export default function OurApproach({ fadeClass = '' }) {
  return (
    <section className={`section approach-section ${fadeClass}`}>
      <div className="container">
        <div className="section-header fade-in">
          <span className="eyebrow">How We Work</span>
          <h2>Our <span className="text-accent">Approach</span></h2>
          <div className="section-divider"></div>
          <p style={{ maxWidth: '580px', margin: '1.5rem auto 0' }}>
            SISDI integrates football and education within school environments to
            nurture disciplined, confident, and well-rounded young individuals.
          </p>
        </div>

        <div className="grid-4 fade-in-stagger">
          {STEPS.map((s) => (
            <div className="approach-card" key={s.n}>
              <div className="approach-number">{s.n}</div>
              <h5>{s.title}</h5>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
